// src/components/PhoneIcon.jsx
import React from 'react';
import PropTypes from 'prop-types';

/**
 * PhoneIcon renders an animated phone SVG icon.
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes to apply
 * @param {number} props.width - Width of the SVG
 * @param {number} props.height - Height of the SVG
 */
const PhoneIcon = ({ className = '', width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeDasharray="64"
      strokeDashoffset="64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 3c0.5 0 2.5 4.5 2.5 5c0 1 -1.5 2 -2 3c-0.5 1 0.5 2 1.5 3c0.39 0.39 2 2 3 1.5c1 -0.5 2 -2 3 -2c0.5 0 5 2 5 2.5c0 2 -1.5 3.5 -3 4c-1.5 0.5 -2.5 0.5 -4.5 0c-2 -0.5 -3.5 -1 -6 -3.5c-2.5 -2.5 -3 -4 -3.5 -6c-0.5 -2 -0.5 -3 0 -4.5c0.5 -1.5 2 -3 4 -3Z"
    >
      <animate
        fill="freeze"
        attributeName="stroke-dashoffset"
        dur="0.6s"
        values="64;0"
      />
    </path>
  </svg>
);

PhoneIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default PhoneIcon;
